var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-11ac8d9a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "viewAppointmentHeader"
};
const _hoisted_2 = { class: "flex flex-row justify-between items-center" };
const _hoisted_3 = {
    id: "view-appointment-title",
    class: "break-all w-[71%]"
};
const _hoisted_4 = { class: "flex flex-row gap-4" };
const _hoisted_5 = {
    key: 0,
    id: "view-appointment-edit-icon"
};
const _hoisted_6 = {
    key: 1,
    id: "view-appointment-delete-icon"
};
const _hoisted_7 = { id: "view-appointment-close-icon" };
const _hoisted_8 = { class: "text-sm text-gray-700 font-medium" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { key: 1 };
const _hoisted_11 = {
    class: "appointmentDetailsContainer",
    id: "appointment-details-container"
};
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "border-[0.5px] border-t-[1px] border-gray-200 mt-3 mb-2" }, null, -1));
const _hoisted_13 = { class: "text-gray-700 font-medium" };
import { CalendarEventService } from '@/service/CalendarEventService';
import { resetAppState as resetBookAppointmentState } from '@/states/book_appointment';
import AppState, { getTargetTimezone, resetAppState, } from '@/states/view_appointment';
import { CheckCircleIcon, Edit01Icon, FaceSadIcon, FaceSmileIcon, Trash01Icon, XCircleIcon, XCloseIcon, } from '@gohighlevel/ghl-icons/24/outline';
import { UIContentWrap, UIModal, UIModalContent, UIModalFooter, UISpin, } from '@gohighlevel/ghl-ui';
import moment from 'moment';
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useNotify } from '../../composition/notification';
import { openEditAppointmentModal } from '../../states/view_appointment';
import DeleteAppointmentModal from '../common/DeleteAppointmentModal.vue';
import UIDropdown from '../common/UIDropdown.vue';
import AppointmentDetails from './AppointmentDetails.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ViewAppointment',
    props: {
        showModal: Boolean,
        isLoading: Boolean,
        onCancelClick: Function,
        router: Object,
    },
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const { sendNotification } = useNotify();
        const appointmentStatus = ref('confirmed');
        const isClassBookingView = ref(false);
        const cancelApptLoader = ref(false);
        const showDeleteModal = ref(false);
        const statusChanged = ref(false);
        const selectedStatusOption = ref({
            label: t('appointmentModal.confirmed'),
            value: 'confirmed',
            icon: CheckCircleIcon,
        });
        // Watch for changes in the appointment status and update the 'appointmentStatus' and 'selectedStatusOption'
        watch(() => { var _a; return (_a = AppState.appointmentDetail) === null || _a === void 0 ? void 0 : _a.appointmentStatus; }, newValue => {
            if (newValue) {
                appointmentStatus.value = newValue;
                updateSelectedStatusOption(newValue);
            }
        });
        // Update the 'selectedStatusOption' based on the provided value
        const updateSelectedStatusOption = (value) => {
            const option = apptStatusOptions.value.find(option => option.value === value);
            selectedStatusOption.value = option;
        };
        // Watch for changes in 'AppState.calendarDetail' and 'AppState.appointmentDetail' and update 'isClassBookingView' accordingly
        watch(() => [AppState.calendarDetail, AppState.appointmentDetail], ([calendarDetails, appointmentDetails]) => {
            var _a, _b, _c;
            const source = ['appointments_page'];
            if (calendarDetails && appointmentDetails) {
                const value = !source.includes((_a = AppState.receivedData) === null || _a === void 0 ? void 0 : _a.source) &&
                    ((_b = AppState.calendarDetail) === null || _b === void 0 ? void 0 : _b.isClassBookingCalendar) &&
                    !!((_c = AppState.appointmentDetail) === null || _c === void 0 ? void 0 : _c.webinarId);
                isClassBookingView.value = value;
            }
        });
        // Function to handle the selected appointment status
        const setSelectedAppointmentStatus = (e) => {
            appointmentStatus.value = e.value;
            updateAppointmentStatus(e.value);
        };
        const updateAppointmentStatus = (status) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g;
            cancelApptLoader.value = true;
            // Check if the appointment is not editable or 'contactId' is missing
            if (!((_a = AppState.appointmentDetail) === null || _a === void 0 ? void 0 : _a.editable) ||
                !((_b = AppState.appointmentDetail) === null || _b === void 0 ? void 0 : _b.contactId)) {
                return;
            }
            if (status === 'cancelled') {
                if (AppState.appointmentDetail.appointmentStatus === 'cancelled') {
                    return;
                }
                else if (!window.confirm('Are you sure you want to cancel this appointment?')) {
                    return;
                }
            }
            const apptData = {
                ignoreFreeSlotValidation: true,
                appointmentStatus: status,
                contact: {
                    id: (_c = AppState.calendarDetail) === null || _c === void 0 ? void 0 : _c.id,
                },
                startTime: moment((_d = AppState.appointmentDetail) === null || _d === void 0 ? void 0 : _d.startTime)
                    .tz(AppState.timezone)
                    .format(),
                endTime: moment((_e = AppState.appointmentDetail) === null || _e === void 0 ? void 0 : _e.endTime)
                    .tz(AppState.timezone)
                    .format(),
                ignoreDateRange: true,
                toNotify: false,
                meetingLocationType: 'custom',
                address: (_f = AppState.appointmentDetail) === null || _f === void 0 ? void 0 : _f.address,
                channel: 'web_app',
                source: 'calendar_page',
            };
            // Update the appointment(s) based on the 'isClassBookingView' value
            if (isClassBookingView.value) {
                const appointmentIds = (_g = AppState.receivedData) === null || _g === void 0 ? void 0 : _g.appointmentIds;
                if (!appointmentIds) {
                    return;
                }
                yield Promise.all(appointmentIds.map(appointmentId => {
                    return CalendarEventService.updateAppointment(appointmentId, apptData);
                }));
            }
            else {
                yield CalendarEventService.updateAppointment(AppState.eventId, apptData);
            }
            // Update the 'appointmentStatus' and 'selectedStatusOption'
            statusChanged.value = true;
            appointmentStatus.value = status;
            updateSelectedStatusOption(status);
            // Show a notification for successful changes
            sendNotification({
                title: t('common.changes_saved'),
                description: '',
                type: 'success',
            });
            // Handle the case when status is 'cancelled', call 'onCancelClick' prop to close the modal
            if (status === 'cancelled') {
                props.onCancelClick();
            }
            cancelApptLoader.value = false;
        });
        // Function to get the icon for the provided status
        const getIconForStatus = (status) => {
            switch (status) {
                case 'confirmed':
                    return CheckCircleIcon;
                case 'new':
                    return XCircleIcon;
                case 'showed':
                    return FaceSmileIcon;
                case 'noshow':
                    return FaceSadIcon;
                default:
                    return CheckCircleIcon;
            }
        };
        // Computed property to get the appointment status options
        const apptStatusOptions = computed(() => {
            var _a, _b;
            const apptStatusMap = {
                confirmed: t('appointmentModal.confirmed'),
                new: t('appointmentModal.unconfirmed'),
                cancelled: t('appointmentModal.cancelled'),
                showed: t('appointmentModal.showed'),
                noshow: t('appointmentModal.no_show'),
                invalid: t('appointmentModal.invalid'),
            };
            const startTime = moment((_a = AppState.appointmentDetail) === null || _a === void 0 ? void 0 : _a.startTime).tz(AppState.timezone);
            const currentStatus = (_b = AppState.appointmentDetail) === null || _b === void 0 ? void 0 : _b.appointmentStatus;
            let statusOptions = [];
            if (startTime === null || startTime === void 0 ? void 0 : startTime.isAfter(moment().tz(AppState.timezone))) {
                statusOptions = [
                    ...statusOptions,
                    ...[
                        {
                            label: t('appointmentModal.confirmed'),
                            value: 'confirmed',
                            icon: getIconForStatus('confirmed'),
                        },
                        {
                            label: t('appointmentModal.unconfirmed'),
                            value: 'new',
                            icon: getIconForStatus('new'),
                        },
                    ],
                ];
            }
            else {
                statusOptions = [
                    ...statusOptions,
                    ...[
                        {
                            label: t('appointmentModal.showed'),
                            value: 'showed',
                            icon: getIconForStatus('showed'),
                        },
                        {
                            label: t('appointmentModal.no_show'),
                            value: 'noshow',
                            icon: getIconForStatus('noshow'),
                        },
                    ],
                ];
            }
            const isCurrentStatusPresentInOptions = statusOptions.find(option => {
                return option.value === currentStatus;
            });
            if (!isCurrentStatusPresentInOptions && currentStatus) {
                statusOptions = [
                    ...statusOptions,
                    {
                        label: apptStatusMap[currentStatus],
                        value: currentStatus,
                        icon: getIconForStatus(currentStatus),
                    },
                ];
            }
            return statusOptions;
        });
        // Function to handle the onClick event for the close icon
        const onClickCloseIcon = (updateApptList = true) => {
            resetAppState();
            resetBookAppointmentState();
            props.onCancelClick(statusChanged.value ? statusChanged.value : updateApptList);
        };
        const toggleDeleteModal = () => {
            showDeleteModal.value = !showDeleteModal.value;
        };
        const isFullDayEvent = computed(() => {
            var _a, _b, _c;
            return (((_a = AppState.appointmentDetail) === null || _a === void 0 ? void 0 : _a.isFullDay) ||
                moment((_b = AppState === null || AppState === void 0 ? void 0 : AppState.appointmentDetail) === null || _b === void 0 ? void 0 : _b.endTime).diff(moment((_c = AppState === null || AppState === void 0 ? void 0 : AppState.appointmentDetail) === null || _c === void 0 ? void 0 : _c.startTime), 'hours') >= 24);
        });
        const appointmentDate = computed(() => {
            var _a, _b;
            const targetTimezone = getTargetTimezone();
            if (!targetTimezone)
                return '';
            const appointmentStartTime = moment((_a = AppState.appointmentDetail) === null || _a === void 0 ? void 0 : _a.startTime).tz(targetTimezone);
            const appointmentEndTime = moment((_b = AppState.appointmentDetail) === null || _b === void 0 ? void 0 : _b.endTime).tz(targetTimezone);
            const formattedStartTime = appointmentStartTime.format('MMM D, YYYY h:mm A');
            const formattedEndTime = appointmentEndTime.format('MMM D, YYYY h:mm A');
            if (isFullDayEvent.value) {
                const startOfDay = appointmentStartTime.startOf('day');
                // subtracting 1 second so that for full day event it is within the sma day itself
                const endOfDay = appointmentEndTime.startOf('day').subtract(1, 'second');
                // If start and end date is same then return the start date
                if (startOfDay.isSame(endOfDay, 'day')) {
                    return formattedStartTime;
                }
                else {
                    // Else return the range
                    return `${formattedStartTime} - ${formattedEndTime}`;
                }
            }
            return formattedStartTime;
        });
        const appointmentTime = computed(() => {
            var _a, _b;
            const targetTimezone = getTargetTimezone();
            if (!targetTimezone)
                return '';
            return isFullDayEvent.value
                ? ''
                : `, ${moment((_a = AppState.appointmentDetail) === null || _a === void 0 ? void 0 : _a.startTime)
                    .tz(targetTimezone)
                    .format('h:mm a')} -
    ${moment((_b = AppState.appointmentDetail) === null || _b === void 0 ? void 0 : _b.endTime)
                    .tz(targetTimezone)
                    .format('h:mm a')}`;
        });
        const onClickEdit = () => {
            var _a;
            AppState.viewUserInfo = false;
            openEditAppointmentModal((_a = AppState.appointmentDetail) === null || _a === void 0 ? void 0 : _a.eventType);
        };
        const showStatus = computed(() => {
            var _a, _b;
            return (((_a = AppState.appointmentDetail) === null || _a === void 0 ? void 0 : _a.editable) &&
                ((_b = AppState.appointmentDetail) === null || _b === void 0 ? void 0 : _b.eventType) === 'appt');
        });
        const appointmentTitle = computed(() => {
            var _a, _b;
            return ((_a = AppState.appointmentDetail) === null || _a === void 0 ? void 0 : _a.isClassBookingEvent)
                ? 'Class booking'
                : (_b = AppState.appointmentDetail) === null || _b === void 0 ? void 0 : _b.title;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIContentWrap), null, {
                default: _withCtx(() => {
                    var _a;
                    return [
                        _createVNode(_unref(UIModal), {
                            show: __props.showModal,
                            width: 450
                        }, _createSlots({
                            header: _withCtx(() => {
                                var _a, _b, _c, _d;
                                return [
                                    (!__props.isLoading)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                            _createElementVNode("div", _hoisted_2, [
                                                _createElementVNode("p", _hoisted_3, _toDisplayString(appointmentTitle.value || _unref(t)('appointmentModal.appointment_details')), 1),
                                                _createElementVNode("div", _hoisted_4, [
                                                    (!((_a = _unref(AppState).appointmentDetail) === null || _a === void 0 ? void 0 : _a.isClassBookingEvent))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                                            _createVNode(_unref(Edit01Icon), {
                                                                class: _normalizeClass(["w-5 h-5 text-gray-700 cursor-pointer", {
                                                                        'cursor-not-allowed opacity-50 pointer-events-none': !((_b = _unref(AppState).appointmentDetail) === null || _b === void 0 ? void 0 : _b.editable),
                                                                    }]),
                                                                onClick: onClickEdit
                                                            }, null, 8, ["class"])
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (!((_c = _unref(AppState).appointmentDetail) === null || _c === void 0 ? void 0 : _c.isClassBookingEvent))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                                            _createVNode(_unref(Trash01Icon), {
                                                                class: _normalizeClass(["w-5 h-5 text-gray-700 cursor-pointer", {
                                                                        'cursor-not-allowed opacity-50 pointer-events-none': !((_d = _unref(AppState).appointmentDetail) === null || _d === void 0 ? void 0 : _d.editable),
                                                                    }]),
                                                                onClick: toggleDeleteModal
                                                            }, null, 8, ["class"])
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    _createElementVNode("div", _hoisted_7, [
                                                        _createVNode(_unref(XCloseIcon), {
                                                            class: "w-5 h-5 text-gray-700 cursor-pointer",
                                                            onClick: _cache[0] || (_cache[0] = ($event) => (onClickCloseIcon(false)))
                                                        })
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_8, _toDisplayString(appointmentDate.value) + " " + _toDisplayString(appointmentTime.value), 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ];
                            }),
                            default: _withCtx(() => [
                                _createVNode(_unref(UIModalContent), { class: "p-0" }, {
                                    default: _withCtx(() => [
                                        (__props.isLoading || cancelApptLoader.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                _createVNode(_unref(UISpin), { class: "h-[420px] overflow-auto flex justify-center items-center" })
                                            ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                                _createElementVNode("div", {
                                                    class: "flex flex-row",
                                                    style: _normalizeStyle({
                                                        height: __props.isLoading ? '420px' : 'auto',
                                                        maxHeight: _unref(AppState).viewUserInfo ? '600px' : 'auto',
                                                        overflow: 'auto',
                                                    })
                                                }, [
                                                    _createElementVNode("div", _hoisted_11, [
                                                        _createVNode(AppointmentDetails, {
                                                            "is-class-booking-view": isClassBookingView.value,
                                                            router: __props.router
                                                        }, null, 8, ["is-class-booking-view", "router"])
                                                    ])
                                                ], 4)
                                            ]))
                                    ]),
                                    _: 1
                                }),
                                _createVNode(DeleteAppointmentModal, {
                                    "show-modal": showDeleteModal.value,
                                    "event-id": _unref(AppState).eventId,
                                    "on-cancel-click": toggleDeleteModal,
                                    "on-delete-click": onClickCloseIcon
                                }, null, 8, ["show-modal", "event-id"])
                            ]),
                            _: 2
                        }, [
                            (!__props.isLoading && !((_a = _unref(AppState).appointmentDetail) === null || _a === void 0 ? void 0 : _a.isClassBookingEvent))
                                ? {
                                    name: "footer",
                                    fn: _withCtx(() => [
                                        _hoisted_12,
                                        _createVNode(_unref(UIModalFooter), {
                                            id: "modal-footer",
                                            type: "primary",
                                            class: "flex flex-grow items-center"
                                        }, {
                                            actionLeft: _withCtx(() => [
                                                _createElementVNode("div", {
                                                    class: _normalizeClass(["flex items-center gap-4", {
                                                            'cursor-not-allowed opacity-50 pointer-events-none': !showStatus.value,
                                                        }])
                                                }, [
                                                    _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(t)('appointmentModal.status')) + " : ", 1),
                                                    _createVNode(UIDropdown, {
                                                        value: selectedStatusOption.value,
                                                        options: apptStatusOptions.value,
                                                        id: "appointment-status",
                                                        label: _unref(t)('appointmentModal.status'),
                                                        "handle-change": setSelectedAppointmentStatus
                                                    }, null, 8, ["value", "options", "label"])
                                                ], 2)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    key: "0"
                                }
                                : undefined
                        ]), 1032, ["show"])
                    ];
                }),
                _: 1
            }));
        };
    }
});
